import { render, staticRenderFns } from "./DocumentOnlineComponent.vue?vue&type=template&id=fc9d06c4&lang=pug"
import script from "./DocumentOnlineComponent.vue?vue&type=script&lang=ts"
export * from "./DocumentOnlineComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc9d06c4')) {
      api.createRecord('fc9d06c4', component.options)
    } else {
      api.reload('fc9d06c4', component.options)
    }
    module.hot.accept("./DocumentOnlineComponent.vue?vue&type=template&id=fc9d06c4&lang=pug", function () {
      api.rerender('fc9d06c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DocumentOnline/DocumentOnlineComponent.vue"
export default component.exports